export default "__VITE_ASSET__bd0e89ae__"